module.exports = "https://cdn.hellotech.com/client-assets/routers_desktop_55b5c98f587e6befad1e56e8bd8b2ec6.webp";